/** Limita la velocidad de reproducción a un rango razonable (0.25×–4×). */
export function clampEscapeRoomPlaybackRate(rate) {
	const n = Number(rate);
	if (!Number.isFinite(n) || n <= 0) return 1;
	return Math.min(4, Math.max(0.25, n));
}

export function applyEscapeRoomVideoPlaybackRate(videoEl, rate) {
	if (!videoEl) return;
	try {
		videoEl.playbackRate = clampEscapeRoomPlaybackRate(rate);
	} catch (_) {}
}

export function formatEscapeRoomPlaybackRateLabel(rate) {
	const r = clampEscapeRoomPlaybackRate(rate);
	if (Math.abs(r - 1) < 0.01) return "1×";
	if (Math.abs(r - Math.round(r)) < 0.01) return `${Math.round(r)}×`;
	return `${r.toFixed(2).replace(/\.?0+$/, "")}×`;
}
